///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { Component, ViewChild } from '@angular/core';
import { KbDateInputBaseComponent } from './../date-input.base.component';
import { DatePickerComponent } from '@progress/kendo-angular-dateinputs';

@Component({
    selector: 'kb-date-picker',
    templateUrl: './date-picker.component.html',
})
export class KbDatePickerComponent extends KbDateInputBaseComponent {
    @ViewChild(DatePickerComponent)
    public datePicker: DatePickerComponent;
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/date-picker/date-picker.component.ts